import { lt, showSuccessAlert } from '@mews/framework';
import { DropDownButton, DropdownItem, IconName } from '@optimus-web/core';
import { copyToClipboard } from '@mews-commander/utils';
import { DataTestId } from '@mews-commander/enums';
import { WithCancellationPolicyId } from '../types';
import { useDeleteCancellationPolicyDialog } from './useDeleteCancellationPolicyDialog';
import { useUpdateCancellationPolicyDialogForm } from './useUpdateCancellationPolicyDialogForm';

export const RowActionCell = ({ cancellationPolicyId }: WithCancellationPolicyId) => {
    const { confirmationDialog, openConfirmationDialog } = useDeleteCancellationPolicyDialog({ cancellationPolicyId });
    const [renderDialog, updateAction] = useUpdateCancellationPolicyDialogForm({ cancellationPolicyId });
    return (
        <>
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <DropdownItem
                    data-test-id={DataTestId.ServiceCancellationPolicyEditButton}
                    label={lt('Edit')}
                    onClick={updateAction}
                />
                <DropdownItem label={lt('Delete')} variant="danger" onClick={openConfirmationDialog} />
                <DropdownItem
                    label={lt('CopyCancellationPolicyId')}
                    onClick={() => {
                        if (copyToClipboard(cancellationPolicyId)) {
                            showSuccessAlert({ description: lt('CopiedSuccessMessage') });
                        }
                    }}
                />
            </DropDownButton>
            {confirmationDialog}
            {renderDialog()}
        </>
    );
};
